export default __webpack_public_path__ + "static/fair_clouds-min-d9a5b53a6e63f9fdaec11b414ca74147.jpg";